
  <!-- Content Wrapper. Contains page content -->
  <!-- <div class="content-wrapper" style="font-size:15px"> -->
    <!-- Content Header (Page header) -->
    <section class="content-header">
           <!-- <div class="float-right">
                {{now | date:'ccc, MMM d, y'}} at {{now | date:'mediumTime'}}
            </div> -->
      <!-- <div class="container-fluid">
        <h2 class="text-center display-6" >Search Client</h2>
      </div> -->
      <!-- /.container-fluid -->
        <mat-toolbar>
            <div class="flex-container">
                <div class="flex-item"><app-search-bar></app-search-bar></div>
                <div class="flex-item">
                    <div style="padding-top: 5px;">
                        <button mat-raised-button type="button" data-toggle="modal" data-target="#modal-default" class="pull-right"><i class="fa-solid fa-user-plus"></i> Customer</button>
                    </div>
                </div>
            </div>
                <app-add-customer></app-add-customer> 

                
        </mat-toolbar>

    </section>

    <!-- Main content -->
    <section class="content">
        <div class="container-fluid">
            <!-- <div class="row mt-3" style=""> -->
                <!-- <div class="col-md-10 offset-md-1"> -->
                    <div class="list-group">
                        <div class="list-group-item">
                            <div class="row">
                                <div class="col px-4">
                                    <div>
                                        <!-- <div class="float-right"> -->
                                        <!-- {{now | date:'ccc, MMM d, y'}} at {{now | date:'mediumTime'}}</div><br><br> -->
                                        <h4>{{ client.first_name }} {{ client.last_name }}</h4>
                                        <!-- <p class="mb-0">Name: GUEST </p> -->
                                        <p class="mb-0"><b>Mobile:</b> {{ client.mobile }}</p>
                                        <p class="mb-0"><b>Email:</b> {{ client.email }}</p>
                                        <p class="mb-0"><b>Address:</b> {{ client.address }}</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- </div> -->
            <!-- </div> -->
        </div>
    </section>

 